import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./ResidentModal.css";
import { Grid } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { createresidentStatus } from "../common/constants/globalconstants";
import { useSelector } from "react-redux";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  padding: "20px !important",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  maxHeight: "80%",
  overflowY: "auto",
  borderRadius:"5px"
};

export default function ResidentModal(props) {
  const {setSuccess, setModalOpen}= props;
  const [errormodalopen, seterrormodalOpen] = React.useState(false);
  const storeuser = useSelector((state) => state.storeuser);

  const [contentsopen, setcontentsOpen] = React.useState("*********");
  const contentopen = () => {
    setcontentsOpen(props.enrollmentFields.SSN);
  };
  const contentclose = () => {
    setcontentsOpen("*********");
  };
  const acnum = props.enrollmentFields.accountNum;
  //let len=acnum.length; //-4
  let star = "";
  const substr = acnum.substring(acnum.length - 4, acnum.length); //length
  for (let i = 1; i <= acnum.length - 4; i++) {
    star = "*" + star;
  }
  const maskacnum = star + substr;
  const [accountsopen, setaccountsOpen] = React.useState(maskacnum);
  const accountopen = () => {
    setaccountsOpen(props.enrollmentFields.accountNum);
  };
  const accountclose = () => {
    setaccountsOpen(maskacnum);
  };
  
  const [mystatus, setmystatus] = React.useState("");
  const getResidentData = (data) => {
    var resStatus = data.residentStatus == "Released" ? "R" : "D";
    if (data.residentStatus === "R" || data.residentStatus === "Released") {
      setmystatus("Released");
    } else {
      setmystatus("Deceased");
    }
   { /*return {
      id: data.residentId, //it cant be 0 for edit enrollment , 0 for new enrolment
      userName: storeuser.email, //storeuser.email, //"rahulbhatia7699@gmail.com"
      //achEDate: data.enroll_date,
      achEDate: data.picker_date,
      payeeLastName: data.lastName,
      payeeFirstName: data.firstName,
      ssn: data.SSN,
      address: data.address.street,
      city: data.address.city,
      state: data.address.state,
      zip: data.address.zip_code,
      phone: data.tele_number,
      contact: data.contact,
      accountNo: data.accountNum,
      residentStatus : resStatus,
    };*/}
    return {
      enrollmentId: data.enrollmentId,
      userName: storeuser.email, //storeuser.email, //"rahulbhatia7699@gmail.com"
      achEDate: data.picker_date,
      residentStatus: resStatus,
    };
  };

  const handlesnackbarClick = () => {
    submitResidentData();
  };
  const submitResidentData = async () => {
    try {
      props.plzclose();
      props.requestindicatordata(true);
      const residentData = getResidentData(props.enrollmentFields);
      const response = await axiosInstance.post(`${createresidentStatus}`,JSON.stringify(residentData));
      if (response.data.isSuccess) {
        //props.requestsnackbardata(true);

        props.requestindicatordata(false);
        //navigate("/ResidentListings");
        setSuccess(true);
        setModalOpen(true);
      } else {
        setSuccess(false);
        seterrormodalOpen(true);
      }
    } catch (error) {
      console.log(error);
      seterrormodalOpen(true);
    }
  };

  return (
    <div>
      <Modal
        open={true}
        onClose={props.plzclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalstyle"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" component="h2">
            Resident Verification
            <IconButton
              aria-label="close"
              onClick={props.plzclose}
              sx={{
                position: "absolute",
                right: 35,
                top: 20,
                color: "white",
                backgroundColor: "red",
                padding: "2px",
                boxShadow: "none",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <hr></hr>
          <Box id="details">
            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    <strong>First name </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {`${props.enrollmentFields.firstName}`}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    {" "}
                    <strong>Last name</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">{`${props.enrollmentFields.lastName}`}</span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    <strong>Date </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {`${props.enrollmentFields.picker_date}`}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    {" "}
                    <strong>Status</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">{`${
                      props.enrollmentFields.residentStatus === "R" ||
                      props.enrollmentFields.residentStatus === "Released"
                        ? "Released"
                        : "Deceased"
                    }`}</span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong>SSN</strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      <Tooltip
                        id="tooltip"
                        onOpen={contentopen}
                        onClose={contentclose}
                        title="  "
                        placement="left-start"
                      >
                        <IconButton id="iconbutton">{contentsopen}</IconButton>
                      </Tooltip>
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>A/C No.</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      <Tooltip
                        id="tooltip"
                        onOpen={accountopen}
                        onClose={accountclose}
                        title="  "
                        placement="right-start"
                      >
                        <IconButton id="iconbutton">{accountsopen}</IconButton>
                      </Tooltip>
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>

            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong>Telephone No</strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {`${props.enrollmentFields.tele_number}`}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Point of Contact</strong>{" "}
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">{`${props.enrollmentFields.contact}`}</span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumnresident">
              <Grid item xs={12}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> Address-Street </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {`${props.enrollmentFields.address.street}`}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> City </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {`${props.enrollmentFields.address.city}`}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    <strong> State </strong>
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {" "}
                      {`${props.enrollmentFields.address.state}`}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumnresident">
              <Grid width="50%">
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Zip Code</strong> <span id="mspan-left">:</span>
                    <span id="modalspan-left">{`${props.enrollmentFields.address.zip_code}`}</span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>

              <Grid width="50%">
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong></strong> <span id="mspan-right"></span>
                    <span id="modalspan-right"></span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>

            <hr></hr>
          </Box>

          <br></br>
          <Box>
            <strong>
              <span id="submit">Do you want to submit this information?</span>
            </strong>
            <Button
              id="btn1"
              variant="contained"
              href="#ResidentListings"
              onClick={handlesnackbarClick}
              type="submit"
            >
              Yes
            </Button>

            <Button
              color="error"
              id="btn2"
              variant="outlined"
              href="#outlined-buttons"
              onClick={props.plzclose}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
      {errormodalopen && (
			<ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
		  )}
    </div>
  );
}
